import { Modal }          from 'rewire-ui';
import billingDialogModel from '../settings/BillingDialogModel';

export class BillingLinkDialogModel extends Modal {
  constructor() {
    super('Invite Failed');

    this.action('cancel', { variant: 'text' })
        .action('manage', this.managePlan, { variant: 'contained' });
  }

  load() {
    this.open();
  }

  async managePlan() {
    return await billingDialogModel.loadStripePortal();
  }
}

const billingLinkDialogModel = new BillingLinkDialogModel();
export default billingLinkDialogModel;
